module.exports = __webpack_public_path__ + "static/media/00-icons-toast-ic-attantion.d0c1f3a0.svg";